<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="empty-title" :class="cn('text-base font-semibold text-primary-900', props.class)">
    <slot />
  </div>
</template>
